import { lazy } from 'react';

const CustomContractes = lazy(() => import('./CustomContractes'));

export default CustomContractes;
